document.addEventListener('DOMContentLoaded', () => {
    const form = document.body.querySelector('form.cart');
    if (form) {
        const submitButton = form.querySelector('[type="submit"]');
        const size = form.querySelector('[name="size"]');
        if (size) {
            submitButton.setAttribute('disabled', 'disabled');

            size.addEventListener('change', (a) => {
                if ('' !== a.target.value) {
                    submitButton.removeAttribute('disabled');
                }
            });
        }
    }
});